module.exports = __webpack_public_path__ + "de61858ea1aed2daabc48cd2acfb6664.jpg";